// extracted by mini-css-extract-plugin
export default {"modalOverlay":"BC-z","modalContent":"CC-z","header":"DC-z","close":"EC-z"};